import AIRefinementIcon from '@assets/images/AIRefinementIcon.svg'
import Box from '@mui/material/Box'
import { SxProps, Theme } from '@mui/material/styles'

type AIRefineIconProps = {
  sx?: SxProps<Theme>
}

const AIRefineIcon = ({ sx }: AIRefineIconProps) => (
  <Box
    component="img"
    src={AIRefinementIcon}
    alt=""
    sx={[{ width: 17, height: 17, objectFit: 'contain' }, ...(Array.isArray(sx) ? sx : [sx])]}
  />
)

export default AIRefineIcon
